






import CustomerForm from '@/context/customer/component/CustomerForm.vue';
import Component from 'vue-class-component';
import { CustomerFormModel } from '@/context/customer/model/CustomerFormModel';
import { FormContainer } from '@/common/mixin/FormContainer';
import { customerApi } from '@/context/customer/api/CustomerApi';

@Component({
  components: {
    CustomerForm
  }
})
export default class CustomerFormContainer extends FormContainer<CustomerFormModel> {
  model!: CustomerFormModel;

  async formApi(): Promise<CustomerFormModel> {
    return await customerApi.form<CustomerFormModel>(
      CustomerFormModel,
      this.$route?.params?.id ? { id: this.$route.params.id } : null
    );
  }
}
